export default __webpack_public_path__ + "static/media/longchamp7.950a816e.jpg";